//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';

export default {
  name: 'product-card-action-favorite',
  props: {
    // element: Object,

    isFavorite: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      isLoggedIn: state => state.user.isLoggedIn,
    }),
    favoriteIconClass() {
      return this.isFavorite ? 'fas me-bmt icon-heart-solid text-primary' : 'far me-bmt icon-heart-regular';
    },
  },
  methods: {
    onClick() {
      if (!this.isLoggedIn) {
        this.$store.dispatch('modal/showSignUp');
        return;
      }
      this.$emit('click');
    },
  },
};
